import React from 'react';
import moment from 'moment';
import { useQuery } from '@apollo/client/react';

import { Grid, Card, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { GET_ME } from '../../graphql/me';
import { GET_TRAINER_CHECK_INS } from '../../graphql/trainer_check_in';
import { GET_GROUP_CALLS } from '../../graphql/group_call';

const localizer = momentLocalizer(moment);

const StyledCalendar = styled(Calendar)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  minHeight: 500,
}));

function CalendarTab({ workoutSessions, user }) {
  const { error: meError, data: meData } = useQuery(GET_ME);
  const trainerId = meData?.me?._id;

  const {
    error: checkInsError,
    data: checkInsData,
  } = useQuery(GET_TRAINER_CHECK_INS, {
    variables: {
      input: {
        trainerId,
        userId: user?._id,
        status: 'SCHEDULED',
        limit: 100,
      },
    },
    skip: !trainerId || !user?._id,
  });
  const {
    error: groupCallsError,
    data: groupCallsData,
  } = useQuery(GET_GROUP_CALLS, {
    variables: {
      input: {
        trainerId,
        status: 'SCHEDULED',
        limit: 100,
      },
    },
    skip: !trainerId,
  });

  const handleSelectEvent = (event) => {
    if (event.resourceType === 'CHECK_IN') {
      return;
    }
    if (event.resourceType === 'GROUP_CALL') {
      window.location.assign(`/trainer/group_calls/${event._id}`);
      return;
    }

    window.location.assign(`/trainer/workout_sessions/${event._id}`);
  };

  const workoutEvents = workoutSessions.map((workoutSession) => {
    const endedAt = workoutSession.completedAt || workoutSession.createdAt;
    const event = { ...workoutSession };
    event.start = new Date(endedAt);
    event.end = new Date(endedAt);
    event.resourceType = 'WORKOUT_SESSION';
    return event;
  });
  const checkInEvents = (checkInsData?.trainerCheckIns || [])
    .filter((checkIn) => checkIn.scheduledStartAt && checkIn.scheduledEndAt)
    .map((checkIn) => ({
      ...checkIn,
      title: `Check-in: ${user?.name || 'Client'}`,
      start: new Date(checkIn.scheduledStartAt),
      end: new Date(checkIn.scheduledEndAt),
      resourceType: 'CHECK_IN',
    }));
  const groupCallEvents = (groupCallsData?.groupCalls || [])
    .filter((groupCall) => groupCall.scheduledStartAt && groupCall.scheduledEndAt)
    .map((groupCall) => ({
      ...groupCall,
      title: `Group call: ${groupCall.title || 'Untitled'}`,
      start: new Date(groupCall.scheduledStartAt),
      end: new Date(groupCall.scheduledEndAt),
      resourceType: 'GROUP_CALL',
    }));
  const events = [...workoutEvents, ...checkInEvents, ...groupCallEvents];

  const latestEvent = events[events.length - 1];

  return (
    <>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={12} md={10}>
          <Card>
            <CardContent>
              {(meError || checkInsError || groupCallsError) && (
                <Typography color="error" variant="body2" sx={{ mb: 2 }}>
                  Scheduled trainer calendar events could not be loaded.
                </Typography>
              )}
              <StyledCalendar
                selectable
                localizer={localizer}
                events={events}
                defaultView="month"
                scrollToTime={latestEvent?.end || new Date()}
                defaultDate={new Date()}
                onSelectEvent={handleSelectEvent}
                onSelectSlot={() => {}}
                tooltipAccessor={(event) =>
                  event.resourceType === 'CHECK_IN'
                    ? event.meetingUrl || 'Scheduled check-in'
                    : event.resourceType === 'GROUP_CALL'
                      ? event.meetingUrl || event.title
                    : event.title
                }
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}

export default CalendarTab;
